export default "__VITE_ASSET__6XVw34Q2__"